import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { setTheme } from "../../../redux/reducers/themeReducer"
import { Sun, Moon } from "../Icon"
import { cn } from "../../../lib/utils"

const THEMES = [
  { value: "light", icon: Sun, label: "Light" },
  { value: "dark", icon: Moon, label: "Dark" },
]

export default function ThemeToggle() {
  const dispatch = useDispatch()
  const current = useSelector((state) => state.theme.mode)

  return (
    <fieldset
      className={cn(
        "inline-flex items-center gap-0.5 m-0 border-0 min-w-0",
        "rounded-lg bg-white/[0.12] p-[3px]",
      )}
      aria-label="Color theme"
      data-testid="theme-toggle"
    >
      {THEMES.map(({ value, icon: Icon, label }) => (
        <button
          key={value}
          className={cn(
            "flex h-[26px] w-[26px] items-center justify-center",
            "rounded-lg border-none bg-transparent text-white/70",
            "cursor-pointer transition-[background,color] duration-150",
            "hover:bg-white/[0.18] hover:text-white",
            current === value && "bg-white/25 text-white",
          )}
          onClick={() => dispatch(setTheme(value))}
          aria-pressed={current === value}
          title={label}
        >
          <Icon size={14} />
        </button>
      ))}
    </fieldset>
  )
}
